import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ISettingsStore } from '@/types'
import type {
  IApiProductSettings,
  IPlacementSettings,
  ISettings,
} from '@/types'

export const useSettingsStore = defineStore('settings', (): ISettingsStore => {
  const accountId = ref('')
  const placementId = ref('')
  const couponId = ref('')

  const productId = 'coupon_builder'
  const placementSettings = ref<IPlacementSettings|null>(null)

  const updatePlacementSettings = (newSettings: ISettings) => {
    if (!newSettings.placement) {
      console.error('Invalid settings provided.')
      return
    }

    const { placement } = newSettings

    placementSettings.value = placement
  }

  const setAccountId = (id: string) => {
    accountId.value = id
  }

  const setPlacementId = (id: string) => {
    placementId.value = id
  }

  const setCouponId = (id: string) => {
    couponId.value = id
  }

  const fetchSettings = async () => {
    try {
      const productSettings: IApiProductSettings | null =
        await getProductSettings(accountId.value, productId)

      const data =
        productSettings?.config ?? productSettings?.data ?? productSettings

      if (data?.placements == null) {
        console.error('coupon_builder', 'No placements found in settings')
        return
      }

      const placementSettings: IPlacementSettings =
        data.placements[placementId.value]

      console.info('coupon_builder', 'placementSettings', placementSettings)

      const settings: ISettings = {
        placement: placementSettings,
      }

      updatePlacementSettings(settings)
    } catch (err) {
      console.error('coupon_builder', 'fetch settings', err)
    }
  }

  const getProductSettings = async (
    accountId: string,
    productId: string,
  ): Promise<IApiProductSettings | null> => {
    const endpoint = import.meta.env.VITE_JAMS_BACKEND_URL
    const path = `unauth/account/products/${accountId}/${productId}`

    const response = await fetch(`${endpoint}/${path}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    try {
      const responseJson: any = await response.json()

      if (!response.ok) {
        throw new Error('API Error')
      }

      return responseJson
    } catch (error) {
      console.error(error)
      return null
    }
  }

  return {
    accountId,
    placementId,
    couponId,
    placementSettings,

    setAccountId,
    setPlacementId,
    setCouponId,
    fetchSettings,
  }
})
